import { render, staticRenderFns } from "./selectPakage.vue?vue&type=template&id=0211651a&scoped=true"
import script from "./selectPakage.vue?vue&type=script&lang=js"
export * from "./selectPakage.vue?vue&type=script&lang=js"
import style0 from "./selectPakage.vue?vue&type=style&index=0&id=0211651a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0211651a",
  null
  
)

export default component.exports